// extracted by mini-css-extract-plugin
export default {"playerEvaluationContainer":"PlayerEvaluationList_playerEvaluationContainer__EHK4j","playerEvaluationList":"PlayerEvaluationList_playerEvaluationList__BQCti"};